import type { ApexOptions } from 'apexcharts'

import { Chart } from '@/composables/chart/Chart'
import type { VariableData } from '@/types/Chart'

export class ChartManager {
  private charts: Chart[]
  private variables: VariableData[]
  private theme: string
  private language: string
  private translate: (v: string) => string

  public constructor(translateFunction: (v: string) => string) {
    this.charts = []
    this.variables = []
    this.theme = ''
    this.language = ''
    this.translate = translateFunction
  }

  public setInitialParams(theme: string, language: string) {
    this.theme = theme
    this.language = language
  }

  public addVariableData(variableData: VariableData) {
    this.variables.push(variableData)
  }

  public async generateChartsData() {
    this.charts = []
    const tempCharts: Chart[] = []

    for (const variableData of this.variables) {
      const chart: Chart = new Chart(variableData, this.translate, this.theme, this.language)
      chart.buildChartData()
      tempCharts.push(chart)
    }
    this.charts = tempCharts
  }

  public updateTheme(theme: string): void {
    for (const chart of this.charts) {
      chart.updateTheme(theme)
    }
  }

  public updateLanguage(language: string, translate: (v: string) => string): void {
    this.translate = translate
    for (const chart of this.charts) {
      chart.updateLanguage(language, translate)
    }
  }

  public getChart(typeId: string): {
    options: ApexOptions | null
    series: {
      name: string
      data: number[]
    }[]
  } {
    const chart: Chart | undefined = this.charts.find((x) => x.variableData.id === typeId)
    if (chart !== undefined) {
      return {
        options: chart.chartOptions,
        series: [
          {
            name: `weather_${chart.variableData.id}`,
            data: chart.variableData.values
          }
        ]
      }
    }
    return {
      options: null,
      series: [
        {
          name: 'undefined',
          data: []
        }
      ]
    }
  }

  public clearCharts() {
    this.charts = []
  }
}
